module.exports = __webpack_public_path__ + "img/default.e6577bf1.svg";